// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"98269fde","598":"fcc73063","703":"beb33790","787":"cebf93eb"}[chunkId] + ".chunk.js";
};